import {Component, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {IonicSlides, ModalController} from '@ionic/angular';
import {Router} from '@angular/router';
import {StorageManagerGatewayCapacitor} from '../../../../../adapters/real/app-services/storage-manager-gateway-capacitor';
import {SwiperComponent} from 'swiper/angular';
import SwiperCore, {Pagination} from 'swiper';

SwiperCore.use([Pagination, IonicSlides]);

@Component({
  selector: 'app-business-welcome',
  templateUrl: './business-welcome.component.html',
  styleUrls: ['./business-welcome.component.scss'],
})
export class BusinessWelcomeComponent implements OnInit {
  @Input() roleChoiceMode = true;
  @Input() pageTitle: string;
  @ViewChild('swiper') swiperComponent: SwiperComponent;
  activeIndex = 0;

  constructor(private router: Router,
              private ngZone: NgZone,
              private modalCtrl: ModalController,
              private storageManagerGatewayCapacitor: StorageManagerGatewayCapacitor) {}

  ionViewDidEnter() {
    this.swiperComponent.swiperRef.update();
  }

  slideNext() {
    this.swiperComponent.swiperRef.slideNext(300);
  }

  slidePrev() {
    this.swiperComponent.swiperRef.slidePrev(300);
  }

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  goToCreateBusiness() {
    this.modalCtrl.dismiss().then(isItDismissed => {
      if (isItDismissed) {
        this.storageManagerGatewayCapacitor.remove('showBusinessWelcomeSlider').subscribe(isItRemoved => {
          if (isItRemoved) {  this.router.navigate(['/business/create-business']); }
        });
      }
    });
  }

  OnSlideChange() {
    this.ngZone.run(() => this.activeIndex = this.swiperComponent.swiperRef.activeIndex);
  }
}
